import React from 'react'
import * as AiFillSetting from 'react-icons/ai';
// import * as AiOutlinePlus from 'react-icons/ai'
import * as  IoIosArrowDown  from "react-icons/io";
import './Trellosidebar.css'
const Setting = () => {
  return (
   <div className='divallcontainer'> 
    <div className='d-flexdiv'>
        <div className = 'diviconsdiv'>
            <AiFillSetting.AiFillSetting/>
            </div>
        <p className='divcolormem'>Settings
         </p>
        
        
    </div>
     <div className='divextractdiv'>

     < IoIosArrowDown.IoIosArrowDown/>
     
     
     </div>
     </div>
  )
}

export default Setting